import { Link } from "react-router-dom";
import { FiArrowRight, FiArrowUpRight } from "react-icons/fi";
import { certifications, expertise, profile, stats } from "../data/profile";
import "../styles/Home.css";

const Home = () => (
  <div className="page">
    <section className="hero">
      <div className="hero__copy">
        <p className="hero__eyebrow animate-in">
          <span className="hero__pulse" aria-hidden="true" />
          {profile.location}
        </p>

        <h1 className="hero__title animate-in stagger-1">
          Observability
          <br />
          <span className="gradient-text">Architect.</span>
        </h1>

        <p className="lede hero__lede animate-in stagger-2">{profile.intro}</p>

        <div className="hero__actions animate-in stagger-3">
          <a
            className="btn btn--primary"
            href={profile.resumePdf}
            target="_blank"
            rel="noopener noreferrer"
          >
            View resume <FiArrowUpRight />
          </a>
          <Link className="btn" to="/about">
            About me <FiArrowRight />
          </Link>
        </div>
      </div>

      <div className="hero__portrait animate-in stagger-2">
        <img src={profile.photo} alt={profile.name} />
      </div>
    </section>

    <section className="section">
      <div className="stats">
        {stats.map(({ value, label }, i) => (
          <div key={label} className={`glass-card stat animate-in stagger-${i + 1}`}>
            <span className="stat__value gradient-text">{value}</span>
            <span className="stat__label">{label}</span>
          </div>
        ))}
      </div>
    </section>

    <section className="section">
      <h2 className="section-label">What I work with</h2>
      <ul className="expertise">
        {expertise.map(({ area, tools }, i) => (
          <li key={area} className={`expertise__row animate-in stagger-${i + 1}`}>
            <span className="expertise__index">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="expertise__area">{area}</span>
            <span className="expertise__tools">
              {tools.map((tool) => (
                <span key={tool} className="tag">
                  {tool}
                </span>
              ))}
            </span>
          </li>
        ))}
      </ul>
      <Link className="link-arrow" to="/skills">
        All technologies <FiArrowRight />
      </Link>
    </section>

    <section className="section">
      <h2 className="section-label">Certifications</h2>
      <div className="cert-grid">
        {certifications.map(({ src, alt }) => (
          <div key={src} className="cert-grid__item">
            <img src={src} alt={alt} loading="lazy" />
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default Home;
